import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '.';
import type { Form } from '../types/analytics';

const initialState: Form = {
  formName: '',
  formType: '',
  leadId: '',
  formData: {
    visitorZipCode: '',
    modelOfInterest: {
      modelFamily: '',
      modelLine: [],
    },
    preferredDealer: '',
    preferredContactMethod: '',
    preferredBookingDate: '',
    preferredBookingTime: '',
    preferredPurchaseTime: '',
    topicOfInterest: '',
    tradeIn: {
      vehicleMake: '',
      vehicleModel: '',
      vehicleYear: '',
      vehicleMileage: '',
    },
  },
};

const formSlice = createSlice({
  name: 'contactForm',
  initialState,
  reducers: {
    setForm: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

export const selectForm = (state: RootState) => state.contactForm;

export const { setForm } = formSlice.actions;

export default formSlice.reducer;
